export class OrganizationConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên tổ chức',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Domain',
        key: 'domain',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/expert/organization/organization.const.ts